<template>
  <div class="activity-configurator-step-view-mode pt-10 pb-10 clearfix">
    <template v-if="question">
      <BooleanStep v-if="question && question.type === 'Boolean'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <InstructionStep v-else-if="question && question.type === 'SurveyInstruction'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <NumberScaleStep v-else-if="question && question.type === 'NumberScale'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <IndexStep v-if="question && question.type === 'Index'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails"></IndexStep>
      <CustomScaleStep v-else-if="question && question.type === 'CustomScale'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <VASStep v-else-if="question && question.type === 'VAS'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <NumberStep v-else-if="question && question.type === 'Number'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <TextStep v-else-if="question && question.type === 'Text'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <DateTimeStep v-else-if="question && question.type === 'DateTime'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <MultiChoiceStep v-else-if="question && question.type === 'MultiChoice'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <ImageChoiceStep v-else-if="question && question.type === 'Image'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <DropDownStep v-else-if="question && question.type === 'DropDown'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <MeasurementsStep v-else-if="question && question.type === 'Measurements'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <LogStep v-else-if="question && question.type === 'Log'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <ValidatedEntryStep v-else-if="question && question.type === 'ValidatedEntry'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <GpSkinStep v-else-if="question && question.type === 'GPSkin'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <ImageCaptureStep v-else-if="question && question.type === 'ImageCapture'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <WongBakerStep v-else-if="question && question.type === 'WongBaker'" :question="question" :mode="mode" :activityDetails="activityDetails" />
      <MedicationSelectorStep v-else-if="question && question.type === 'MedicationSelector'" :question="question" :mode="mode" :activityDetails="activityDetails" />
      <AudioRecording v-else-if="question && question.type === 'AudioRecording'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <VideoRecording v-else-if="question && question.type === 'VideoRecording'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <SurveyCompletion v-else-if="question && question.type === 'SurveyCompletion'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <SkinAnalyser v-else-if="question && question.type === 'SkinAnalyser'" :question="question" :mode="mode" :showStep="showStep" :activityDetails="activityDetails" />
      <div v-else></div>
    </template>
  </div>
</template>

<script>
// STEPS
import BooleanStep from "@/components/activity-library/activity-steps/boolean";
import InstructionStep from "@/components/activity-library/activity-steps/instruction";
import NumberScaleStep from "@/components/activity-library/activity-steps/number-scale";
import CustomScaleStep from "@/components/activity-library/activity-steps/custom-scale";
import VASStep from "@/components/activity-library/activity-steps/vas";
import NumberStep from "@/components/activity-library/activity-steps/number-response";
import TextStep from "@/components/activity-library/activity-steps/text-response";
import DateTimeStep from "@/components/activity-library/activity-steps/date-time";
import MultiChoiceStep from "@/components/activity-library/activity-steps/multi-choice";
import ImageChoiceStep from "@/components/activity-library/activity-steps/image";
import DropDownStep from "@/components/activity-library/activity-steps/dropdown";
import MeasurementsStep from "@/components/activity-library/activity-steps/measurements";
import LogStep from "@/components/activity-library/activity-steps/log";
import ValidatedEntryStep from "@/components/activity-library/activity-steps/validated-entry";
import IndexStep from "@/components/activity-library/activity-steps/index-step";
import GpSkinStep from "@/components/activity-library/activity-steps/gp-skin";
import ImageCaptureStep from "@/components/activity-library/activity-steps/image-capture";
import WongBakerStep from "@/components/activity-library/activity-steps/wong-baker";
import MedicationSelectorStep from "@/components/activity-library/activity-steps/medication-selector";
import AudioRecording from "@/components/activity-library/activity-steps/audio-recording";
import VideoRecording from "@/components/activity-library/activity-steps/video-recording";
import SurveyCompletion from "@/components/activity-library/activity-steps/custom-completion-screen";
import SkinAnalyser from "@/components/activity-library/activity-steps/skin-analyser";

export default {
  name: "ActivityStepView",
  data() {
    return {};
  },
  components: {
    BooleanStep,
    InstructionStep,
    NumberScaleStep,
    CustomScaleStep,
    VASStep,
    NumberStep,
    TextStep,
    DateTimeStep,
    MultiChoiceStep,
    ImageChoiceStep,
    DropDownStep,
    MeasurementsStep,
    LogStep,
    ValidatedEntryStep,
    IndexStep,
    GpSkinStep,
    ImageCaptureStep,
    WongBakerStep,
    MedicationSelectorStep,
    AudioRecording,
    VideoRecording,
    SurveyCompletion,
    SkinAnalyser
  },
  props: {
    question: {},
    activityDetails: {},
    mode: { type: String, default: "VIEW" },
    showStep: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.question-container {
  display: block;
  .step {
    margin-right: 15px;
  }
}
.activity-configurator-step-view-mode {
  h1,
  h2,
  h3 {
    font-weight: 200;
    strong {
      font-weight: bold;
    }
  }
  .instruction_title {
    h1,
    h2,
    h3 {
      font-weight: 200;
      strong {
        font-weight: bold !important;
      }
    }
  }
  .type_select {
    color: #c7cfd9;
  }
  .form-control:disabled {
    background-color: #fff;
    border: solid 2px #d3dfe4;
  }
  .wid300 {
    max-width: 300px !important;
  }
  .img-style {
    padding-top: 20px;
    height: 300px;
    width: 500px;
    padding-bottom: 20px;
  }

  .question_body {
    word-break: break-all;
    color: #959fa4;
  }

  .read_only_question {
    border-left: 1px solid #d3dfe4 !important;
    background-color: #f5f8fa;
  }

  .icon-style {
    color: #57dd7a;
    font-size: 25px;
    padding-top: 20px;
    background-color: #d6f0de;
    padding: 7px;
    padding-bottom: 3px;
    border-radius: 25px;
  }

  .font-style {
    color: #57dd7a;
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 30px;
  }

  // Style for quick fixes bootstrap after migration (before redesign should be removed)

  .option-section {
    &:after {
      content: "";
      clear: both;
      display: block;
    }
    .col-sm-3 {
      float: left;
    }
  }

  // END of style for quick fixes bootstrap after migration (before redesign should be removed)

  h1,
  h2,
  h3 {
    font-weight: 200;
  }

  .img-style {
    padding-top: 20px;
    height: 300px;
    width: 500px;
    padding-bottom: 20px;
  }

  .question_body {
    word-break: break-all;
    color: #959fa4;
  }

  .read_only_question {
    border-left: 1px solid #d3dfe4 !important;
    background-color: #f5f8fa;
  }

  .icon-style {
    color: #57dd7a;
    font-size: 25px;
    padding-top: 20px;
    background-color: #d6f0de;
    padding: 7px;
    padding-bottom: 3px;
    border-radius: 25px;
  }

  .font-style {
    color: #57dd7a;
    font-size: 16px;
    padding-top: 10px;
    padding-bottom: 30px;
  }

  .text-style {
    color: #969090;
    text-align: right;
  }

  .btn-style {
    margin-top: 10px;
    width: 80px;
    height: 29px;
    margin-bottom: 50px;
  }

  .custom-btn {
    background: #00baf9;
    color: #fff;
    width: 220px;
  }

  .pad-top50 {
    padding-top: 50px;
  }

  .form-control {
    border-radius: 2px;
  }

  .custom-para {
    padding-bottom: 20px;
    font-size: 20px;
  }

  .mar-bot20 {
    margin-bottom: 20px;
  }

  .error-style {
    font-size: 12px;
    color: #ff4848;
    padding-bottom: 5px;
  }
  .readonly {
    background: #f7f7f7;
  }
  .btn-disabled {
    color: white;
    background-color: #c6c2c2;
    border: #c6c2c2;
  }

  .text-color {
    color: #888;
  }

  .survey-name {
    color: #00baf9;
    font-size: 20px;
  }

  .pad-left50 {
    padding-left: 50px;
  }
  .branching_section {
    // background-color: #f5f8fa;
    // border: solid 1px #d3dfe4;
    padding: 5px 0px;
    .branching_image {
      max-width: 120px;
      max-height: 120px;
      width: 100%;
      border: 1px solid #ccc;
    }
  }
  .custom-btn-bg {
    background: linear-gradient(to left, #4b6fe6, #00baf9);
    color: #fff;
  }

  .mar-bot20 {
    margin-bottom: 20px;
  }

  .pad-left100 {
    padding-left: 100px;
  }

  .mar-bot0 {
    margin-bottom: 0px !important;
  }

  .card {
    border: 1px solid rgba(0, 0, 0, 0.125);
    padding: 15px;
    margin-bottom: 16px;
  }

  .question_color,
  input {
    color: #666769;
    font-size: 14px;
  }

  .radio-option {
    margin: 0px;
    label {
      padding-left: 5px;
    }
  }

  .input-text {
    width: 100%;
    border-radius: 2px;
    outline: none;
    border: 1px solid #ccc;
    height: 35px;
    text-indent: 10px;
  }

  .date-input {
    border-radius: 20px;
    outline: none;
    border: 1px solid #ccc;
    height: 35px;
    text-indent: 10px;
  }

  .pad-top20 {
    padding-top: 20px;
  }

  .vertical-vue-slider {
    height: 300px !important;
    width: 4px;
    padding: 11px;
    margin-left: 30px;
    top: 10px;
  }

  .vertical-vue-slider-vas {
    width: 4px;
    padding: 11px;
    margin-left: 30px;
  }

  .horizontal-vue-slider {
    height: 8px;
    width: 100%;
  }

  .img-size {
    width: 100%;
    height: auto;
    float: none;
    max-width: 120px;
    max-height: 120px;
    padding-left: 5px;
  }

  label {
    font-weight: normal !important;
    word-break: break-all;
    color: #959fa4;
  }

  .modal-dialog {
    width: 500px !important;
  }

  .instruction_title {
    word-break: break-all;
    font-size: 18px;
    font-weight: 500 !important;
  }
  .instruction_info {
    word-break: break-all;
  }

  .edit_button {
    background-color: #ffffff;
    border: 1px solid #d3dfe4;
    font-size: 12px;
  }

  .drag_img {
    position: relative;
    bottom: 1px;
    margin-right: 6px;
  }

  .scaleLabels {
    font-size: 12px;
    color: #666669;
  }

  .scaleLabels-vas {
    font-size: 12px;
    color: #666669;
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .display-inline {
    display: inline-block;
    padding-left: 5px;
  }
  /deep/ .vue-slider-component .vue-slider-tooltip {
    display: none;
  }
  input[type="radio"] {
    vertical-align: middle;
  }

  #reorderingModal {
    .move-btn {
      background-color: #4c8ce4;
      border-color: #4c8ce4;
      border-radius: 20px;
      padding: 5px 30px;
    }
    button.close {
      margin-top: -2px;
    }
    .modal-title {
      font-size: 15px;
      font-weight: bold;
    }
    .invalid-feedback {
      display: block;
      font-size: 13px;
      max-width: 165px;
    }
  }

  .lang-img-options .col-auto {
    margin-right: 126px !important;
  }

  .lang-img-options .col-auto:last-of-type {
    margin-right: 0 !important;
  }

  .language-name {
    color: #959fa4;
  }

  .group-scoring {
    &__container {
      border-radius: 3px;
      &-filled,
      &-edit {
        border: solid 1px #b0bac9;
        background-color: #b0bac9;
        height: 40px;
        padding: 10px 13px;
      }

      &-only-display {
        height: 30px;
      }
    }

    &__name-input {
      flex-basis: 75%;
    }
  }
  .section_weight {
    background-color: #eee;
    border-radius: 3px;
    color: #000;
    line-height: 26px;
    padding: 0 10px;
    text-align: right;
  }
  .branching-border {
    border-top: 1px solid #d3dfe4;
    // border-bottom: 1px solid #d3dfe4;
  }
  .clearbranchimage {
    vertical-align: middle;
    padding: 3px;
    border: 1px solid #d3dfe4;
    background: #d3dfe4;
    opacity: 0.6;
    border-radius: 3px;
  }
  .branchingsavebtn {
    width: 88px;
    border-radius: 4px;
    background-color: #4c8ce4;
    border-radius: 2px solid #4c8ce4;
    display: flex;
    justify-content: center;
    padding: 6px;
    cursor: pointer;
  }
  .branchingbtntext {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #ffffff;
  }
  .cancelbranchingbtn {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #666669;
    margin: 14px;
    cursor: pointer;
  }
  .branchingsteptitalname {
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: normal;
    color: #000000;
  }
  .branchingstep {
    padding: 20px 5px 5px 20px;
  }
  .branchingstepcount {
    font-size: 14px;
    color: #000000;
    font-weight: bold;
  }
  .beanchinglogictext {
    font-size: 14px;
    color: #000000;
  }
  .Add_another_branch {
    font-size: 12px;
    font-weight: bold;
    color: #4c8ce4;
    cursor: pointer;
  }
  .branchingsteptitalname p {
    margin-bottom: 0;
  }
  .branching-select-option {
    width: 50px;
    height: 23px;
    border-radius: 3px;
    font-size: 12px;
    border: solid 1px #d3dfe4;
    padding-top: 1px;
  }
  .priority-no {
    position: relative;
    top: 13px;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
  }
  .priority-img {
    opacity: 0.6;
  }
  .rotate-180deg {
    transform: rotate(180deg);
  }
  .fa-info-circle {
    color: #959fa4;
    margin-left: -13px;
  }
  .group-scoring__container-empty {
    background-color: #ffffff;
    height: 30px;
    padding: 5px 13px;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23B0BAC9FF' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  .ql-editor.p-0 {
    overflow-y: unset;
  }
}
</style>
